import DistributorForm from "../../../components/distributorForm";

function NewDistributor() {
  return <DistributorForm />;
}

export default NewDistributor;
